import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  signInTitle: {
    id: 'Authentication.signInTitle',
    defaultMessage: 'Sign in',
  },
  createAccountTitle: {
    id: 'Authentication.createAccountTitle',
    defaultMessage: 'Create Account',
  },
  emailLabel: {
    id: 'Authentication.emailLabel',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'Authentication.emailPlaceholder',
    defaultMessage: 'Email',
  },
  passwordLabel: {
    id: 'Authentication.passwordLabel',
    defaultMessage: 'Password',
  },
  confirmPasswordLabel: {
    id: 'Authentication.confirmPasswordLabel',
    defaultMessage: 'Confirm Password',
  },
  passwordPlaceholder: {
    id: 'Authentication.passwordPlaceholder',
    defaultMessage: 'Password',
  },
  signInBtn: {
    id: 'Authentication.signInBtn',
    defaultMessage: 'Sign in',
  },
  createAccountBtn: {
    id: 'Authentication.createAccountBtn',
    defaultMessage: 'Create Account',
  },
  confirmUserBtn: {
    id: 'Authentication.confirmUserBtn',
    defaultMessage: 'Confirm',
  },
  verificationTitle: {
    id: 'Authentication.verificationTitle',
    defaultMessage: 'Verify Account',
  },
  verifyLabel: {
    id: 'Authentication.verifyLabel',
    defaultMessage: 'Verification code',
  },
  verifyPlaceholder: {
    id: 'Authentication.verifyPlaceholder',
    defaultMessage: '######',
  },
  resendBtn: {
    id: 'Authentication.resendBtn',
    defaultMessage: 'Click to resend the code',
  },
})
